// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Style imports:
// import './DeleteBookmarkModal.scss';
// Component imports:
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
// Service imports:
// Action imports:
import { deleteBookmark } from '../../redux-store/actions/bookmarkActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';
import { IBookmark } from '../../types/api/BookmarkTypes';

interface IOwnProps {
    bookmark: IBookmark,
    onHide(): void
};
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & IOwnProps;

class DeleteBookmarkModal extends React.Component<Props> {
    render () {
        const { bookmark, onHide, deleteBookmark, accessTokenV2 } = this.props;
        return (
            <Modal
                show
                centered
                backdrop='static'
                onHide={onHide}
                id='DeleteBookmarkModal'
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Bookmark
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete?
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className='CloseButton'
                        variant='dark'
                        onClick={() => onHide()}
                    >
                        Cancel
                    </Button>
                    <Button
                        className='DeleteButton'
                        variant='dark'
                        onClick={() => {
                            deleteBookmark(accessTokenV2, bookmark.id);
                            onHide();
                        }}
                    >
                        Yes, delete bookmark
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps({ loginReducer }: RootState) {
    const { accessTokenV2 } = loginReducer;
    return {
        accessTokenV2
    }
}

const connector = connect(mapStateToProps, { deleteBookmark });
export default connector(DeleteBookmarkModal);